import { observer } from 'mobx-react';
import { Link } from '../../../../../../Resource/Types';
import ModalReactions from '../../../../../Modal/ModalReactions';
import RenderInviteParticipantsModal from './RenderInviteParticipantsModal';
import InviteParticipantStore from './Store';

interface Props {
  links: ReadonlyArray<Link>;
  inviteParticipantStore: InviteParticipantStore;
}

function InviteParticipantModal({ inviteParticipantStore, links }: Props) {
  return (
    <>
      <RenderInviteParticipantsModal store={inviteParticipantStore} links={links} />
      <ModalReactions store={inviteParticipantStore.modalStore} />
    </>
  );
}

export default observer(InviteParticipantModal);
